import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loginAction } from '../../../utils/redux/auth/authActions';
import './Login.css';

const Login = () => {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        const response = await dispatch(loginAction({ email: email, password: password }));
        if (response?.success === true) {
            navigate('/');
        }
    };


    return (
        <div className={`container-main`}>
            <div className='img-container'>
                {/* <img src='./Logo.png' alt='Tulio' height={100} width={300} /> */}
            </div>
            <div className="auth-container">
                <h2>Login</h2>
                <form onSubmit={handleSubmit}>
                    <input
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    <button type="submit">Login</button>
                </form>
                {/* <a className="auth-link" href="/signup">Don't have an account? Sign up</a> */}
            </div>
        </div>
    )
}

export default Login